interface Props {
  x1: number;
  y1Top: number;
  y1Bot: number;
  x2: number;
  y2Top: number;
  y2Bot: number;
  color: string;
  opacity?: number;
}

/**
 * A cubic-curve ribbon connecting (x1, y1Top..y1Bot) on the left
 * to (x2, y2Top..y2Bot) on the right. Control points at the midpoint
 * horizontally produce a smooth S-curve.
 */
export function FlowRibbon({ x1, y1Top, y1Bot, x2, y2Top, y2Bot, color, opacity = 0.38 }: Props) {
  const cx1 = x1 + (x2 - x1) * 0.4;
  const cx2 = x2 - (x2 - x1) * 0.4;
  const path = [
    `M ${x1} ${y1Top}`,
    `C ${cx1} ${y1Top}, ${cx2} ${y2Top}, ${x2} ${y2Top}`,
    `L ${x2} ${y2Bot}`,
    `C ${cx2} ${y2Bot}, ${cx1} ${y1Bot}, ${x1} ${y1Bot}`,
    `Z`,
  ].join(" ");
  return <path d={path} fill={color} fillOpacity={opacity} />;
}
